import React from 'react';
import { Navigate } from 'react-router-dom';

const ProtectedRoute = ({ children }) => {
  // LocalStorage'dan authentication durumunu kontrol et
  const isAuthenticated = localStorage.getItem('isAuthenticated') === 'true';
  const userEmail = localStorage.getItem('userEmail');

  // Eğer kullanıcı giriş yapmamışsa login sayfasına yönlendir
  if (!isAuthenticated || !userEmail) {
    return <Navigate to="/giris" replace />;
  }

  // Eğer kullanıcı giriş yapmışsa, korunan sayfayı göster
  return children;
};

export default ProtectedRoute;
